/**
 * Exceptions for striptags used in thread messages
 *
 * @type {number}
 */
export const THREAD_MESSAGE_STRIPTAGS_EXCEPTIONS = [
  'strong',
  'a',
  'img',
  'u',
];
